import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ApiConfig } from './config/api.config';
import { LabcoreRequest } from '../models/labcore-request.model';
import { LabcoreLaboratoryTests } from '../models/labcore-laboratory-tests.model';
import { LabcoreEmailFile } from '../models/labcore-email-file.model';

@Injectable()
export class LaboratoryTestsService{

    constructor(
        private http: HttpClient,
        private api: ApiConfig    
    ){}

    getLaboratoryTests(obj: LabcoreRequest) : Observable<any>{
        return this.http.post<any>(this.api.url + '/laboratory-tests', obj);
    }

    sendEmailOfOrderPDF(obj: LabcoreEmailFile) : Observable<any>{
        return this.http.post<any>(this.api.url + '/laboratory-tests/sendEmail', obj);
    }
}



// WEBPACK FOOTER //
// /app/src/app/shared/services/laboratory-tests.service.ts